import { render } from "./SelfAssessmentV2Question.vue?vue&type=template&id=8c7a4082&scoped=true"
import script from "./SelfAssessmentV2Question.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2Question.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2Question.vue?vue&type=style&index=0&id=8c7a4082&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7a4082"]])

export default __exports__